import { memo, useEffect, useRef, useCallback } from 'react';
import { BzButton, BzPopoverOverlay } from '../../../components';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row, Dropdown } from 'react-bootstrap';
import moment from 'moment/moment';
import Broker from './Broker';
import Order from './Order';
import ExchangeNotificationMessages from './ExchangeNotificationMessages';
import Popover from 'react-bootstrap/Popover';
import { handleModal } from '../../../redux/actions/modals';
import { DEFAULT_PAGE_SIZE, EXCHANGE_NAME_API, EXCHANGE_NAME_NOTIFICATION, LOCAL_STORAGE_KEYS, MESSAGE_HUB_CHIPS } from '../../../utils/global_variables';
import { getNotificationFromLocalStorage, isUserIsAGuest, setNotificationToLocalStorage } from '../../../utils/global_functions';
import { clearNseState, getMessagesBroker, getMessagesNse, getMessagesOrders, setNotifCountBroker, setNotifCountExchange, setNotifCountOrder } from '../../../redux/actions/messages';
import useInfiniteScroll from '../../../hooks/useInfiniteScroll';


const Notification = ({ brokerPageNo, ordersPageNo, NsePageNo, setBrokerPageNo, setOrdersPageNo, setNsePageNo, children, placement, handleNotification, notificationShowPopover, setNotificationShowPopover, notificationExchange, arrExchangeType, notificationActiveChip, isExpanded, setIsExpanded, ...props }) => { //  Hari K :06-11-2023: BT-109371 message hub -receiving props


    const dispatch = useDispatch();
    const { arrOrders, arrNse, arrBroker, isReachedLimit } = useSelector(state => state.messages); //  Hari K :06-11-2023: BT-109371 message hub -receving isReachedLimit

    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    const handleToggle = useCallback((state) => {
        if (!isUserIsAGuest('notification')) {
            setNotificationShowPopover(state);
        } else {
            setNotificationShowPopover(false);
        }
    }, [setNotificationShowPopover]);
    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    //Vaibhav Singh : BT-109371: 17-10-2023: Notfication Handler Implemented for Exchange,Order,Brokers Notification API
    useEffect(() => {
        if (arrNse?.length && !isExpanded && notificationExchange === EXCHANGE_NAME_API.NSE_EQ_API) {
            const prevData = getNotificationFromLocalStorage(`${LOCAL_STORAGE_KEYS.NOTIFICATION_DETAILS_EXCHANGE}_${objLoginSession?.data?.user_id}`);
            if (prevData?.exchangeMessage?.length) {
                const notifFromExchange = arrNse?.filter((f) => {
                    return !prevData?.exchangeMessage?.find((ele) => {
                        return f?.time === ele?.time;
                    });
                });
                if (notifFromExchange?.length > 0) { // Hari K:02-11-2023, BT-109371 message hub - handle view functionality-start
                    dispatch(setNotifCountExchange(notifFromExchange?.length));
                } else { }
                const msgObj = {
                    exchangeMessage: arrNse
                };
                setNotificationToLocalStorage(msgObj, objLoginSession?.data?.user_id, 'EXCHANGE');
            }
            else {
                dispatch(setNotifCountExchange(arrNse?.length));
                const msgObj = {
                    exchangeMessage: arrNse
                };
                setNotificationToLocalStorage(msgObj, objLoginSession?.data?.user_id, 'EXCHANGE');
            }
        }
    }, [arrNse, notificationExchange]);
    useEffect(() => {
        if (arrOrders?.length && !isExpanded) {
            const prevData = getNotificationFromLocalStorage(`${LOCAL_STORAGE_KEYS.NOTIFICATION_DETAILS_ORDER}_${objLoginSession?.data?.user_id}`);
            if (prevData?.orders?.length) {
                const notifFromOrder = arrOrders?.filter((f) => {
                    return !prevData?.orders?.find((ele) => {
                        return f?.orderId === ele?.orderId;
                    });
                });
                if (notifFromOrder?.length > 0) { // Hari K:02-11-2023, BT-109371 message hub - handle view functionality-start
                    dispatch(setNotifCountOrder(notifFromOrder?.length));
                } else { }
                const msgObj = {
                    orders: arrOrders
                };
                setNotificationToLocalStorage(msgObj, objLoginSession?.data?.user_id, 'ORDER');
            }
            else {
                dispatch(setNotifCountOrder(arrOrders?.length));
                const msgObj = {
                    orders: arrOrders
                };
                setNotificationToLocalStorage(msgObj, objLoginSession?.data?.user_id, 'ORDER');
            }
        }
    }, [arrOrders]);

    useEffect(() => {
        if (arrBroker?.length && !isExpanded) {
            const prevData = getNotificationFromLocalStorage(`${LOCAL_STORAGE_KEYS.NOTIFICATION_DETAILS_BROKER}_${objLoginSession?.data?.user_id}`);
            if (prevData?.brokers?.length) {
                const notifFromBroker = arrBroker?.filter((f) => {
                    return !prevData?.brokers?.find((ele) => {
                        return moment(ele?.sendMsgTime, 'YYYY-MM-DD HH:mm:ss').format("DD MMM' YY h:mm A") === moment(f?.sendMsgTime, 'YYYY-MM-DD HH:mm:ss').format("DD MMM' YY h:mm A");
                    });
                });
                if (notifFromBroker?.length > 0) { // Hari K:02-11-2023, BT-109371 message hub - handle view functionality-start
                    dispatch(setNotifCountBroker(notifFromBroker?.length));
                } else { }
                const msgObj = {
                    brokers: arrBroker
                };
                setNotificationToLocalStorage(msgObj, objLoginSession?.data?.user_id, 'BROKER');
            }
            else {
                dispatch(setNotifCountBroker(arrBroker?.length));
                const msgObj = {
                    brokers: arrBroker
                };
                setNotificationToLocalStorage(msgObj, objLoginSession?.data?.user_id, 'BROKER');
            }
        }
    }, [arrBroker]);

    // const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
    //     <div
    //         ref={ref}
    //         onClick={(e) => {
    //             e.preventDefault();
    //             onClick(e);
    //         }}
    //     >
    //         {children}
    //     </div>
    // ));

    // Hari K:02-11-2023, BT-109371 message hub - handle view functionality-start
    const handleViewAll = () => {
        // Hari k :02-11-2023  if we dont scroll and directly click on view all this condition will run-start
        // Ameersha N :15-11-2023 SAT-109371 message hub - issue - index increasing after scroll end - Start
        if (brokerPageNo === 5) {
            dispatch(getMessagesBroker({ pageNo: brokerPageNo }));
            setBrokerPageNo(prev => prev + 1);
        }
        if (ordersPageNo === 1) {
            dispatch(getMessagesOrders({ pageNo: ordersPageNo }));
            setOrdersPageNo(prev => prev + 1);
        }
        if (NsePageNo === 5) {
            dispatch(getMessagesNse(notificationExchange, {
                noofhrs: 1,
                pageNo: NsePageNo,
                pageSize: DEFAULT_PAGE_SIZE.EXCHANGE_MESSAGES_PAGE_SIZE
            }));
            setNsePageNo(prev => prev + 1);
        }
        // Ameersha N :15-11-2023 SAT-109371 message hub - issue - index increasing after scroll end - End
        // Hari k :02-11-2023, if we dont scroll and directly click on view all this condition will run-end
        setNotificationShowPopover(false);
        setIsExpanded(!isExpanded);
        dispatch(handleModal([{ "MESSAGES": true }]));
    };
    // Hari K:02-11-2023, BT-109371 message hub - handle view functionality-end


    // Hari K:01-11-2023 SAT-109371 message hub - infinity scroll -start
    const targetDiv = useRef(null);

    const onScroll = () => {
        handleScroll();
    };

    const [isNearBottom, handleScroll] = useInfiniteScroll(targetDiv, 100);

    useEffect(() => {
        // Ameersha N :15-11-2023 SAT-109371 message hub - issue - index increasing after scroll end - Start
        if (isNearBottom) {
            if (notificationActiveChip === MESSAGE_HUB_CHIPS.ORDERS && isReachedLimit === false) {
                dispatch(getMessagesOrders({ pageNo: ordersPageNo }));
                setOrdersPageNo(prev => prev + 1);
            }
            else if (notificationActiveChip === MESSAGE_HUB_CHIPS.BROKER && isReachedLimit === false) {
                dispatch(getMessagesBroker({ pageNo: brokerPageNo }));
                setBrokerPageNo(prev => prev + 1);
            }
            else if (notificationActiveChip === MESSAGE_HUB_CHIPS.EXCHANGES && isReachedLimit === false) {
                dispatch(getMessagesNse(EXCHANGE_NAME_API.NSE_EQ_API, {
                    noofhrs: 1,
                    pageNo: NsePageNo,
                    pageSize: DEFAULT_PAGE_SIZE.EXCHANGE_MESSAGES_PAGE_SIZE
                }));
                setNsePageNo(prev => prev + 1);
            }
        }
        // Ameersha N :15-11-2023 SAT-109371 message hub - issue - index increasing after scroll end - End
    }, [isNearBottom]);

    // Hari K:01-11-2023 SAT-109371 message hub - infinity scroll-end

    useEffect(() => {
        if (notificationActiveChip === MESSAGE_HUB_CHIPS.ORDERS && arrOrders?.length === DEFAULT_PAGE_SIZE.ORDER_MESSAGES_PAGE_SIZE) {
            setOrdersPageNo(2);
        }

    }, [notificationActiveChip, arrOrders, setOrdersPageNo]);

    // Hari K:01-11-2023, BT-109371 message hub - to handle drop down change-start
    const handleEchangeDropDown = async (name, value) => {
        setNsePageNo(2);
        dispatch(clearNseState());
        handleNotification(name, value);
    };
    // Hari K:01-11-2023, BT-109371 message hub - drop down change-end

    const BzPopover = (
        <Popover className='notifications-popover'>
            <Popover.Header className='p-3 bdr-btm'>
                <Row className='g-0 mb-3'>
                    <Col>
                        <div className='font-medium font-size5 color-text'>Notifications</div>
                    </Col>
                </Row>
                <Row className='g-0 horizontal-scroll-wrap'>
                    <Col>
                        <div className='submenu-wrapper Notifications-menu d-flex align-items-center py-1'>
                            <div onClick={() => handleNotification('broker')} className={`submenuItem ${notificationActiveChip == 'broker' ? 'active' : ''}`}>Broker</div>
                            <div onClick={() => handleNotification('order')} className={`submenuItem ${notificationActiveChip == 'order' ? 'active' : ''}`}>Order</div>
                            <div className={`submenuItem ${notificationActiveChip == 'exchange' ? 'active' : ''} d-flex flex-row align-items-center`}>
                                <div onClick={() => handleNotification('exchange', notificationExchange)}>{EXCHANGE_NAME_NOTIFICATION[notificationExchange] ? EXCHANGE_NAME_NOTIFICATION[notificationExchange] : notificationExchange?.replace('_', ' ')}</div>
                                <div>
                                    <Dropdown>
                                        <Dropdown.Toggle>
                                            <div className='icon-12 icon-arrowdown icon-dark ms-2'></div>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {arrExchangeType?.map((each) => (
                                                <Dropdown.Item key={each} onClick={() => handleEchangeDropDown('exchange', each)}>
                                                    <div>{(EXCHANGE_NAME_NOTIFICATION[each]) ? EXCHANGE_NAME_NOTIFICATION[each] : each.replace('_', ' ')}</div>
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Popover.Header>
            <Popover.Body className='px-3' ref={targetDiv} onScroll={onScroll}>
                {notificationActiveChip === MESSAGE_HUB_CHIPS.BROKER ? <Broker arrBroker={arrBroker} /> : notificationActiveChip === MESSAGE_HUB_CHIPS.ORDERS ? <Order arrOrders={arrOrders} /> : notificationActiveChip === MESSAGE_HUB_CHIPS.EXCHANGES ? <ExchangeNotificationMessages arrNse={arrNse} notificationExchange={notificationExchange} /> : null}
            </Popover.Body>
            <Row className='g-0 mt-2 p-3 bdr-top'>
                <Col>
                    <BzButton className='btn btn-md btn-primary btn-block' onClick={handleViewAll}>View All</BzButton>
                </Col>
            </Row>
        </Popover>
    );

    return (

        <BzPopoverOverlay{...props} rootClose={notificationShowPopover} onToggle={prev => handleToggle(prev)} show={notificationShowPopover} trigger={'click'} placement={placement} popover={BzPopover}   >
            {children}
        </BzPopoverOverlay>

    );
};



export default memo(Notification);